module.exports = __webpack_public_path__ + "static/media/50.ffb71bbf.svg";